export function cloneSnapshotMap(snapshot) {
  if (!snapshot) {
    return null;
  }
  return JSON.parse(JSON.stringify(snapshot));
}

export function applyDraftFieldEdit(snapshot, fieldKey, value, comment, normalizeEntry) {
  const previousEntry = snapshot?.[fieldKey];
  const previousNormalized = normalizeEntry(fieldKey, previousEntry);
  const nextEntry = {
    value,
    comment: comment ?? '',
    lastUpdated: new Date().toISOString(),
    source: 'Manual',
  };
  if (previousNormalized.sourceDocument) {
    nextEntry.sourceDocument = previousNormalized.sourceDocument;
  }
  if (previousNormalized.sourceDocumentUrl) {
    nextEntry.sourceDocumentUrl = previousNormalized.sourceDocumentUrl;
  }
  return {
    ...snapshot,
    [fieldKey]: nextEntry,
  };
}

/** One narrative block for the current extract run (legacy arrays show the latest entry only). */
export function normalizeSnapshotNarrativeEntry(raw) {
  if (raw == null) {
    return null;
  }
  if (Array.isArray(raw)) {
    if (raw.length === 0) {
      return null;
    }
    return normalizeSnapshotNarrativeEntry(raw[raw.length - 1]);
  }
  if (typeof raw === 'object') {
    const value = raw.value;
    if (value == null || String(value).trim() === '') {
      return null;
    }
    return {
      value: String(value),
      lastUpdated: raw.lastUpdated ?? null,
      from: raw.from ?? null,
    };
  }
  const text = String(raw).trim();
  if (!text) {
    return null;
  }
  return { value: text, lastUpdated: null, from: null };
}

export function snapshotVersionLabel(version) {
  if (!version) {
    return '';
  }
  const stamp = version.createdAt || version.updatedAt;
  const dateText = stamp ? new Date(stamp).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }) : '';
  return dateText ? `${version.name} (${dateText})` : version.name;
}
